import { render, staticRenderFns } from "./AgreementPopup.vue?vue&type=template&id=1953c1eb&scoped=true&"
import script from "./AgreementPopup.vue?vue&type=script&lang=js&"
export * from "./AgreementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPopup.vue?vue&type=style&index=0&id=1953c1eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953c1eb",
  null
  
)

export default component.exports